import { useNavigate } from 'react-router-dom';
import { AlertCircle, Settings, ArrowRight } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

const FIELD_LABELS = {
  billing_name: 'Fatura Ünvanı',
  billing_tax_number: 'Vergi Numarası',
  billing_tax_office: 'Vergi Dairesi',
  billing_address: 'Fatura Adresi',
  billing_city: 'Fatura Şehri',
  billing_district: 'Fatura İlçesi',
};

export function MissingBillingInfoModal({ open, onClose, missingFields = [] }) {
  const navigate = useNavigate();

  if (!open) return null;

  const handleGoToSettings = () => {
    onClose();
    navigate('/settings');
  };

  return (
    <Modal open={open} onClose={onClose} title="Fatura Bilgileri Eksik">
      <div className="flex items-start gap-3 mb-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertCircle size={20} className="text-amber-600" />
        </div>
        <div className="text-sm text-slate-700 leading-relaxed">
          Ödeme işlemine geçmeden önce <strong>Firma Ayarları</strong>'nda
          fatura bilgilerinizi tamamlamanız gerekiyor. Bu bilgiler hem
          ödeme sırasında ödeme sağlayıcı tarafından zorunlu tutuluyor,
          hem de e-faturanızda kullanılacak.
        </div>
      </div>

      {missingFields.length > 0 && (
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mb-5">
          <div className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
            Eksik Alanlar
          </div>
          <ul className="space-y-1.5">
            {missingFields.map((field) => (
              <li key={field} className="flex items-center gap-2 text-sm text-slate-700">
                <span className="w-1.5 h-1.5 rounded-full bg-amber-500" />
                {FIELD_LABELS[field] || field}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="flex flex-col-reverse sm:flex-row gap-2 justify-end">
        <Button variant="secondary" onClick={onClose}>
          Vazgeç
        </Button>
        <Button onClick={handleGoToSettings}>
          <Settings size={16} />
          Firma Ayarları'na Git
          <ArrowRight size={16} />
        </Button>
      </div>
    </Modal>
  );
}
